import { z } from "zod";

import {
  BusinessPartnerTableColumns,
  BusinessPartnerType,
  BusinessPartnerTypeWithAll,
} from "./-constants";

export const BusinessPartnerTableFilterSchema = z.object({
  // ページネーション
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),
  // ソート
  sortColumn: z.nativeEnum(BusinessPartnerTableColumns).optional(),
  sortOrder: z.enum(["asc", "desc"]).optional(),
  // タブフィルタ
  businessPartnerType: z
    .nativeEnum(BusinessPartnerTypeWithAll)
    .default(BusinessPartnerTypeWithAll.CORPORATION),
  // フィルタ
  freeText: z.string().optional(),
  businessPartnerTypeIn: z.array(z.nativeEnum(BusinessPartnerType)).optional(),
});

export type BusinessPartnerTableFilterType = z.infer<
  typeof BusinessPartnerTableFilterSchema
>;
